import type { FunctionComponent } from 'react';

import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';

import Ellipsis from '../../../components/ellipsis/ellipsis';
import { Link } from '../../../components/link/link';
import { ObjectIcon } from '../../../components/object_icon/object_icon';
import { parseObjectIconInfo } from '../../../utils/parse_object_icon_info';

import styles from './asset_title.module.css';

type Props = {
  object: SearchItemEntity;
  link?: string;
};

const AssetTitle: FunctionComponent<Props> = (props) => {
  const { object, link } = props;
  const content = (
    <div className={styles.title_wrapper}>
      <Ellipsis
        componentProps={{ className: styles.ellipsis }}
        tooltipText={object.title}
      >
        <ObjectIcon
          className={styles.title_icon}
          info={parseObjectIconInfo(object)}
          textAlign
        />
        {object.title}
      </Ellipsis>
    </div>
  );

  if (link) {
    return (
      <Link className={styles.root} to={link}>
        {content}
      </Link>
    );
  }

  return <span className={styles.root}>{content}</span>;
};

export default AssetTitle;
